// Tenant currency (iter392). Set once from /api/public/branding; every money
// label in the app reads the symbol from here.
export const CURRENCIES = {
  usd: { symbol: '$', name: 'US Dollar' },
  gbp: { symbol: '£', name: 'British Pound' },
  aud: { symbol: 'A$', name: 'Australian Dollar' },
  nzd: { symbol: 'NZ$', name: 'New Zealand Dollar' },
  inr: { symbol: '₹', name: 'Indian Rupee' },
  cad: { symbol: 'C$', name: 'Canadian Dollar' },
  eur: { symbol: '€', name: 'Euro' },
};

let current = 'usd';

export const setCurrency = (code) => {
  const c = String(code || 'usd').toLowerCase();
  current = CURRENCIES[c] ? c : 'usd';
};

export const getCurrency = () => current;
export const isUsd = () => current === 'usd';
export const cs = (code) => (CURRENCIES[String(code || current).toLowerCase()] || CURRENCIES.usd).symbol;
export const currencyCode = () => current.toUpperCase();
export const formatMoney = (amount, code) =>
  `${cs(code)}${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
